const join = (arr, joiner) => (arr ? arr.filter(item => !!item).join(joiner) : '')

export default join
